import { SignUpTemplate } from '@/templates'

const SignUp = (): JSX.Element => {
  return <SignUpTemplate />
}

export default SignUp
